import styled from 'styled-components';

export const StyledSpinner = styled.div`
  position: fixed;
  inset: 0;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;
